import { Link, useLocation } from "react-router-dom";
import "./AdminAreaSwitcher.css";

const areas = [
  { id: "publishing", label: "Avwakin Publishing", path: "/admin/dashboard" },
  { id: "development", label: "Avwakin Development", path: "/avwakindevelopment/admin" },
  { id: "entertainment", label: "Avwakin Entertainment", path: "/avwakinentertainment/admin" },
];

export default function AdminAreaSwitcher() {
  const pathname = useLocation().pathname.toLowerCase();
  const activeArea = pathname.startsWith("/avwakindevelopment/admin")
    ? "development"
    : pathname.startsWith("/avwakinentertainment/admin")
      ? "entertainment"
      : "publishing";

  return (
    <nav className="adminAreaSwitcher" aria-label="Switch admin area">
      {areas.map(area => (
        <Link key={area.id} to={area.path} className="adminAreaLink" aria-current={activeArea === area.id ? "true" : undefined}>
          {area.label}
        </Link>
      ))}
    </nav>
  );
}
